export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const CLEAR_ALL_NOTIFICATION = 'CLEAR_ALL_NOTIFICATION';
export const addNotification = (notification, params = {}) => ({
	type: ADD_NOTIFICATION,
	payload: { notification, params },
	meta: {
		allowedDuringApiCall: true,
	},
});

export const clearNotification = (id) => ({
	type: CLEAR_NOTIFICATION,
	payload: { id },
});

export const clearAllNotification = () => ({
	type: CLEAR_ALL_NOTIFICATION,
	payload: {},
});
